var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c("div", { staticClass: "wl-content" }, [
      _vm.data.userType == "2"
        ? _c("img", {
            staticClass: "img",
            attrs: { src: "src/assets/icons/svg/userlogoClient.svg" },
          })
        : _vm._e(),
      _vm.data.userType == "1"
        ? _c("img", {
            staticClass: "img",
            attrs: { src: "src/assets/icons/svg/userlogo.svg" },
          })
        : _vm._e(),
      _c("div", { staticClass: "wl-content-container" }, [
        _c("h3", [_vm._v(_vm._s(_vm.data.commentUser))]),
        _c("p", { staticClass: "wl-description" }, [
          _vm._v(_vm._s(_vm.data.comment)),
        ]),
        _c("p", { staticClass: "wl-date" }, [
          _vm._v(_vm._s(_vm._f("formatDate")(_vm.data.commentTimeStamp))),
        ]),
      ]),
      _vm.showOperation
        ? _c("div", [
            _c("i", {
              staticClass: "fa fa-reply wl-icon-reply",
              attrs: { "aria-hidden": "true" },
              on: { click: _vm.toggleCommentVisible },
            }),
            _c("i", {
              class: _vm.iconClass(),
              attrs: { "aria-hidden": "true" },
              on: { click: _vm.toogleExpand },
            }),
          ])
        : _vm._e(),
    ]),
    _vm.hasChild && _vm.expandChild
      ? _c(
          "ul",
          _vm._l(_vm.data.children, function (item, index) {
            return _c("tree-item", {
              key: index,
              attrs: {
                data: item,
                parent: _vm.data,
                level: _vm.currentLevel,
                onAdd: _vm.onAdd,
                index: index,
              },
            })
          }),
          1
        )
      : _vm._e(),
    _vm.showComment
      ? _c(
          "div",
          { staticClass: "wl-reply-container" },
          [
            _c("div", { staticClass: "wl-reply-title" }, [
              _c("span", [_vm._v("Reply")]),
              _c("span", [_vm._v(_vm._s(_vm.data.name))]),
            ]),
            _c("add-comment", {
              staticClass: "wl-text-area-grey",
              attrs: {
                onCancel: _vm.toggleCommentVisible,
                onAdd: _vm.onAdd,
                pid: _vm.data.id,
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }